'use strict'; 

let util = require('../core/util'); 
let CartUtility = require('./CartUtility'); 
var parallel = require("async/parallel");


/**
 * @class OrderService
 */
module.exports = class OrderService {

    constructor(param) {
        const init = util.buildInitParam(param); 
        this.initParams=init;
        this.LANG = init.lang;
        this.EVENT_CART_CREATED = 'cart:created';
        this.EVENT_CART_FETCHED = 'cart:fetched';
        this.EVENT_CART_UPDATED = 'cart:updated';

        this.EVENT_ORDER_CREATED = 'order:created';
        this.EVENT_ORDER_FETCHED = 'order:fetched';
        this.EVENT_ORDER_UPDATED = 'order:updated';

        this.SHIPPING_SERVICE_LABEL = 'Shipping';

        this._EventBus = init._EventBus;
        this.STATE = init._STATE;

        this._cartsUrl = (id = null, key = false) => {
            return `${init.baseUrl + init.restPrefix + init.abcGatewayPrefix}carts${id ? '/' : ''}${key ? key + '=' : ''}${id ? id : ''}`;
        }
        
        this._cartsConsolidatedUrl = (id = null) => {
            return `${init.baseUrl + init.restPrefix + init.abcGatewayPrefix}carts${id ? '/' + id : ''}/consolidated`;
        }
        
        this._ordersUrl = (id = null, key = false) => {
            return `${init.baseUrl + init.restPrefix + init.abcGatewayPrefix}orders${id ? '/' : ''}${key ? key + '=' : ''}${id ? id : ''}`;
        }

        this._myOrdersUrl = `${init.baseUrl + init.restPrefix + init.abcGatewayPrefix}orders/by-customer`;
        
        this._shippingMethodsUrl = function(id){
            return init.baseUrl + init.restPrefix + init.abcGatewayPrefix + 'shipping-methods' + (id ? '/' + id : '');
        }
        
        this._statesUrl = function(id){
            return init.baseUrl + init.restPrefix + init.abcGatewayPrefix + 'states' + (id ? '/' + id : '');
        }
        
        this._discountCodesUrl = function(id, key = false){
            return `${init.baseUrl + init.restPrefix + init.abcGatewayPrefix}discount-codes${id ? '/' : ''}${key ? key + '=' : ''}${id ? id : ''}`;
        }

        this._shoppingListUrl = function(id){
            return `${init.baseUrl + init.restPrefix + init.abcGatewayPrefix}shopping-lists${id ? '/' : ''}${id ? id : ''}`;
        }

        this._applyCouponDiscountUrl = init.baseUrl + init.restPrefix + init.backboneGatewayPrefix + 'coupon/v1/applyDiscountCodeOnExternalTotal';
        this._removeCouponDiscountUrl = init.baseUrl + init.restPrefix + init.backboneGatewayPrefix + 'coupon/v1/removeDiscountCodeOnExternalTotal';
        this._reCalculateCouponDiscountUrl = init.baseUrl + init.restPrefix + init.backboneGatewayPrefix + 'coupon/v1/reCalculateDiscountCodeOnExternalTotal';

        this._getReviewComments = (businessUnit, orderId, lineItemId) => {
            return `${init.baseUrl + init.restPrefix + init.backboneGatewayPrefix}storage/v2/document/reviewComment/${businessUnit}/${orderId}/${lineItemId}`;
        }

        this._saveReviewCommentUrl = `${init.baseUrl + init.restPrefix + init.backboneGatewayPrefix}storage/v2/document/reviewComment`;

        this._getCommentsV1Url = orderId => `${init.baseUrl + init.restPrefix + init.backboneGatewayPrefix}storage/v1/document/orderid/comment/${orderId}`;

        this._saveCommentV1Url = `${init.baseUrl + init.restPrefix + init.backboneGatewayPrefix}storage/v1/document/orderid/comment`;

        this._paymentsUrl = function(id){
            return `${init.baseUrl + init.restPrefix + init.abcGatewayPrefix}payments${id ? '/' + id : ''}`;
        }
        
        this._getShippingOptionsUrl = `${init.baseUrl + init.restPrefix + init.backboneGatewayPrefix}get-shipping-options`;

        this._shippingRecalculateArrivalDateUrl = `${init.baseUrl + init.restPrefix + init.backboneGatewayPrefix}shipping/v1/recalculatearrivaldate`;

        this._getTenantDefinitionUrl = function(productTypeId) {
            return init.baseUrl + init.restPrefix + init.backboneGatewayPrefix + 'products/product-types/' + productTypeId + '/tenant-definition'; 
        };

    };

    /**
     * get cart by user Id, supports anonymous & logged in customer Id as well.
     * @param {String} userId 
     * @param {Boolean} isLoggedIn 
     */
    async getCart(userId, isLoggedIn){
        if(isLoggedIn){
            // if logged in then fetch cart by customerId
            return await util.makeGETRequest(this._cartsUrl(userId, 'customerId')).then(this._dispatchCartIsFetched.bind(this)); 
        }else{
            // if not logged in then fetch all carts by anonymousId
            // where, limit, offset, sort
            return await util.makeGETRequest(this._cartsUrl(userId, 'anonymousId')).then(function(response){
                if(response.results){
                    // query was correct
                    // send only first cart result if exists
                    return (response.results.length ? response.results[0] : {statusCode:404});
                }
                // Other issue, pass as it is
                return response;
            }).then(this._dispatchCartIsFetched.bind(this)); 
        }
    }

    /**
     * Dispatch Cart Created Event
     * @param {Object} res 
     */
    _dispatchCartIsCreated(res){
        if(res.id){
            this._EventBus.dispatch(this.EVENT_CART_CREATED, res);
        }
        return res;
    }

    /**
     * Dispatch Cart Fetched Event
     * @param {Object} res 
     */
    _dispatchCartIsFetched(res){
        if(res.id){
            this._EventBus.dispatch(this.EVENT_CART_FETCHED, res);
        }
        return res;
    }

    /**
     * Dispatch Cart Updated Event
     * @param {Object} res 
     */
    _dispatchCartIsUpdated(res){
        if(res.id){
            this._EventBus.dispatch(this.EVENT_CART_UPDATED, res);
        }
        return res;
    }

    /**
     * Get cart by cart Id
     * 
     * @param {String} cartId
     * 
    */
    getCartById(cartId, params){
        return util.makeGETRequest(this._cartsUrl(cartId), params).then(this._dispatchCartIsFetched.bind(this));
    }

    /**
     * create cart
     * 
     * @param {Object} lineItem 
     * @param {String} userId 
     * @param {Boolean} isLoggedIn 
     * @param {Object} variantInfo 
     * @param {Object} designerData 
     * @param {String} taxMode
     *  External / Platform / Disabled
     * @param {String} taxRoundingMode
     *  HalfEven / HalfUp / HalfDown 
     * @param {Object} cartInfo 
     *  Additional Cart related attributes
     */
    createCart(lineItem, userId, isLoggedIn, variantInfo, designerData, taxMode, taxRoundingMode, cartInfo = {}) {
        var _this = this;
        var lineItemRequest = {};
        // Build lineItem Request 
        try{
            lineItemRequest = CartUtility.prepareLineItemRequest(this.LANG, lineItem, variantInfo, designerData, taxMode,this.initParams);
        }catch(e){
            return util.sendValidationError(e);
        }
        // add customFieldVersion to the order 
        var newCart =  {
            currency:lineItem.currencyCode, 
            lineItems:[ lineItemRequest ],
            "custom": {
                "type": {
                    "key":"orderCustomFields"
                },
                "fields": {
                    "customFieldVersion":CartUtility.getCustomFieldVersion(this.initParams)
                }
            }
        }; 
        // If user is logged in, then use customerId key instead of anonymousId
        if (isLoggedIn) {
            newCart.customerId = userId; 
        }else {
            newCart.anonymousId = userId; 
        }
        if(util.typeOf(taxMode, 'string')){
            newCart.taxMode = taxMode; 
        }
        if(util.typeOf(taxRoundingMode, 'string')){
            newCart.taxRoundingMode = taxRoundingMode; 
        }
        if(util.typeOf(cartInfo, 'object')){
            newCart = Object.assign(newCart, cartInfo);
        }
        return util.makePostRequest(this._cartsUrl(), newCart).then(this._dispatchCartIsCreated.bind(this)).then(function(_cart){
            if(_cart.id){
                return _this._addCustomLineItems(_cart, lineItem.customLineItems, lineItem.currencyCode, lineItemRequest, taxMode);
            }
            return _cart;
        });
    }

    /**
     * 
     * @param {Array} lineItems 
     * @param {String} userId 
     * @param {Boolean} isLoggedIn 
     * @param {Object} cartInfo 
     */
    createCartByItems(lineItems = [], cartInfo = {}, userId = null, isLoggedIn = false){
        let _this = this;
        let lineItemRequests = [];
        for(let i = 0, len = lineItems.length; i < len; i++){
            try{
                lineItemRequests.push(CartUtility.prepareLineItemRequest(this.LANG, lineItems[i], lineItems[i].variantInfo, lineItems[i].designerData, cartInfo.taxMode,this.initParams));
            }catch(e){
                return util.sendValidationError(e);
            }
        }
        if(!util.typeOf(cartInfo, 'object') || !cartInfo.currency){
            return util.sendValidationError(new Error('Invalid cartInfo or cart currency'));
        }
        let newCart = Object.assign(cartInfo, {
            lineItems:lineItemRequests,
            "custom": {
                "type": {
                    "key":"orderCustomFields"
                },
                "fields": {
                    "customFieldVersion":CartUtility.getCustomFieldVersion(this.initParams)
                }
            }
        });
        if(userId){
            // If user is logged in, then use customerId key instead of anonymousId
            if (isLoggedIn) {
                newCart.customerId = userId; 
            }else {
                newCart.anonymousId = userId; 
            }
        }
        return util.makePostRequest(this._cartsUrl(), newCart).then(this._dispatchCartIsCreated.bind(this));
    }

    /**
     * Add Item to existing cart
     * @param {Object} cartMeta 
     * @param {Object} lineItem 
     * @param {Object} variantInfo 
     * @param {Object} designerData 
     * @param {String} taxMode
     */
    addItemInCart(cartMeta, lineItem, variantInfo, designerData, taxMode){
        var _this = this;
        var lineItemRequest = {};
        // Build lineItem Request 
        try{
            lineItemRequest = CartUtility.prepareLineItemRequest(this.LANG, lineItem, variantInfo, designerData, taxMode,this.initParams);
            lineItemRequest.action = "addLineItem";
        }catch(e){
            return util.sendValidationError(e);
        }
        // skip calling update external Amount call if custom line Items also exists
        let hasLineItem = lineItem.customLineItems && lineItem.customLineItems.length;
        // add line Item request payload
        return this.updateCart(cartMeta, [ 
            lineItemRequest 
        ], !hasLineItem).then(function(_cart){
            return _this._addCustomLineItems(_cart, lineItem.customLineItems, lineItem.currencyCode, lineItemRequest, taxMode);
        });
    }

    /**
     * Add Multiple Line Items in Cart
     * @param {Object} cartMeta 
     * @param {Array} lineItems 
     * @param {String} taxMode 
     */
    addItemsInCart(cartMeta, lineItems = [], taxMode = null){
        let _this = this;
        let lineItemRequests = [];
        for(let i = 0, len = lineItems.length; i < len; i++){
            try{
                let lineItemRequest = CartUtility.prepareLineItemRequest(this.LANG, lineItems[i], lineItems[i].variantInfo, lineItems[i].designerData, taxMode,this.initParams);
                lineItemRequest.action = "addLineItem";
                lineItemRequests.push(lineItemRequest);
            }catch(e){
                return util.sendValidationError(e);
            }
        }
        // add line Item request payload
        return this.updateCart(cartMeta, lineItemRequests);
    }

    /**
     * Do Recalculate action on cart
     * Prices and tax rates will be updated.
     * This should be called just after create cart call
     * @todo: spatel: Need to reverify that `Do we need this call anymore?`
     * @param {Object} cartMeta 
     */
    reCalculateCart(cartMeta){
        return this.updateCart(cartMeta, [{
            "action":"recalculate", 
            "updateProductData":false
        }]);
    }

    /**
     * Create new Cart and add line Item & Custom line Items into that
     * This will use consolidated endpoint.
     * @param {Object} lineItem 
     * @param {String} userId 
     * @param {Boolean} isLoggedIn 
     * @param {Object} variantInfo 
     * @param {Object} designerData 
     * @param {String} taxMode 
     * @param {Object} cartInfo 
     */
    async newCart(lineItem, userId, isLoggedIn, variantInfo, designerData, taxMode, cartInfo = {}){
        let lineItemRequest = {};
        let customLineItemActions = [];
        // Build lineItem Request 
        try{
            lineItemRequest = CartUtility.prepareLineItemRequest(this.LANG, lineItem, variantInfo, designerData, taxMode,this.initParams);
            customLineItemActions = lineItem.customLineItems ? CartUtility.prepareCustomLineItemRequest(lineItem.customLineItems, undefined, lineItem.currencyCode, this.LANG, true, taxMode) : customLineItemActions;
        }catch(e){
            return util.sendValidationError(e);
        }
        var newCart =  {
            currency:lineItem.currencyCode, 
            lineItems:[ lineItemRequest ],
            "custom": {
                "type": {
                    "key":"orderCustomFields"
                },
                "fields": {}
            }
        }; 
        // If user is logged in, then use customerId key instead of anonymousId
        if (isLoggedIn) {
            newCart.customerId = userId; 
        }else {
            newCart.anonymousId = userId; 
        }
        if(util.typeOf(taxMode, 'string')){
            newCart.taxMode = taxMode; 
        }

        if(util.typeOf(cartInfo, 'object')){
            newCart = Object.assign(newCart, cartInfo);
        }

        // request in fortmat of consolidated endpoint
        let request = {
            cart: newCart, 
            addCustomLineItemAction: {
                actions: customLineItemActions
            }
        };

        return await util.makePostRequest(this._cartsConsolidatedUrl(), request)
            .then(this._postCartUpdate.bind(this))
            .then(this._dispatchCartIsCreated.bind(this));
    }

    /**
     * Add Line Item & Custom Line Items into existing cart
     * This will use consolidated endpoint.
     * 
     * @param {Object} cartMeta 
     * @param {Object} lineItem 
     * @param {Object} variantInfo 
     * @param {Object} designerData 
     * @param {String} taxMode 
     */
    addItem(cartMeta, lineItem, variantInfo, designerData, taxMode){
        let lineItemRequest = {};
        let customLineItemActions = [];
        // Build lineItem Request 
        try{
            lineItemRequest = CartUtility.prepareLineItemRequest(this.LANG, lineItem, variantInfo, designerData, taxMode,this.initParams);
            lineItemRequest.action = "addLineItem";
            customLineItemActions = lineItem.customLineItems ? CartUtility.prepareCustomLineItemRequest(lineItem.customLineItems, undefined, lineItem.currencyCode, this.LANG, true, taxMode) : customLineItemActions;
        }catch(e){
            return util.sendValidationError(e);
        }

        // request in fortmat of consolidated endpoint
        let request = {
            addLineItemAction: {
                version: cartMeta.version,
                actions: [
                    lineItemRequest
                ]
            },
            addCustomLineItemAction: {
                actions: customLineItemActions
            }
        };

        return util.makePostRequest(this._cartsConsolidatedUrl(cartMeta.id), request)
            .then(this._postCartUpdate.bind(this))
            .then(this._dispatchCartIsUpdated.bind(this));
    }

    /**
     * Wrapper for addCustomLineItems
     * @private
     * @param {Object} _cart 
     * @param {Array} customLineItems 
     * @param {String} currencyCode 
     * @param {Object} lineItemRequest 
     * @param {String} taxMode
     */
    _addCustomLineItems(_cart, customLineItems, currencyCode, lineItemRequest, taxMode){
        var _this = this;
        if(_cart.id && customLineItems && lineItemRequest.custom && lineItemRequest.custom.fields.lineItemNumber){
            // Search for line Item last added using lineItemNumber
            var lineItemObject = CartUtility.searchItemByCustomFieldValue(_cart.lineItems, 'lineItemNumber', lineItemRequest.custom.fields.lineItemNumber);
            if(lineItemObject.id){
                return _this.addCustomLineItems(_cart, lineItemObject.id, currencyCode, customLineItems, taxMode);
            }
        }
        return _cart;
    }

    /**
     * Add Custom Line Item for a line Item
     * @param {Object} cartMeta 
     * @param {String} lineItemId 
     * @param {String} currencyCode 
     * @param {*} customLineItems 
     * @param {String} taxMode
     */
    addCustomLineItems(cartMeta, lineItemId, currencyCode, customLineItems, taxMode){
        var customLineItemActions = {};
        // Build customLineItemActions Request 
        try{
            customLineItemActions = CartUtility.prepareCustomLineItemRequest(customLineItems, lineItemId, currencyCode, this.LANG, true, taxMode);
        }catch(e){
            return util.sendValidationError(e);
        }
        // send add custom line Item request payload
        return this.updateCart(cartMeta, customLineItemActions);
    }

    /**
     * Update Line Items custom fields in Bulk
     * @param {Object} cartMeta 
     * @param {Array} lineItems 
     */
    updateLineItemsCustomFields(cartMeta, lineItems){
        let actions = [];

        for(let i = 0, len = lineItems.length; i < len; i++){
            if(!util.typeOf(lineItems[i].customFields, 'object')){
                return util.sendValidationError(new Error('Invalid customFields request parameter'));
            }

            Object.keys(lineItems[i].customFields).map((name) => {

                // process field which should be set of string
                if( name == 'userSelection' && util.typeOf(lineItems[i].customFields[name], 'object')){
                    lineItems[i].customFields[name] = util.objectToSetOfStrings(lineItems[i].customFields[name]);
                    actions.push({
                        "action": "setLineItemCustomField",
                        "lineItemId": lineItems[i].lineItemId,
                        "name": name,
                        "value": lineItems[i].customFields[name]
                    });
                }

                if(name == 'userSelection'  || name == 'mcpDocumentsSource'){
                    lineItems[i].customFields = util.getCustomFieldsV2(name,util.objectToSetOfStrings(lineItems[i].customFields[name]), this.initParams ,lineItems[i].customFields);
                }
                if(this.initParams.supportV1 && name!="userSelection"){
                    actions.push({
                        "action": "setLineItemCustomField",
                        "lineItemId": lineItems[i].lineItemId,
                        "name": name,
                        "value": lineItems[i].customFields[name]
                    });
                }
                if(this.initParams.supportV2){
                    actions.push({
                        "action": "setLineItemCustomField",
                        "lineItemId": lineItems[i].lineItemId,
                        "name": name+"V2",
                        "value": lineItems[i].customFields[name+"V2"]
                    });
                }
                
            });
        }
        
        return this.updateCart(cartMeta, actions);
    }

    /**
     * Update existing Cart Info
     * @param {Object} cartMeta 
     * @param {Array} actions 
     * @param {Boolean} recalculateAmount 
     */
    updateCart(cartMeta, actions, recalculateAmount = true){
        if(!util.typeOf(cartMeta, 'object') || !util.typeOf(actions, 'array') || !cartMeta.id || !cartMeta.version){
            return util.sendValidationError(new Error('Invalid update request parameter'));
        }
        var request = {
            "version":cartMeta.version, 
            "actions":actions
        };
        let _this = this;
        return util.makePostRequest(this._cartsUrl(cartMeta.id), request).then(cart => {
            return _this._postCartUpdate(cart, recalculateAmount);
        }).then(this._dispatchCartIsUpdated.bind(this));
    }

    /**
     * Perform actions needed after cart update
     * e.g. recalculate total for external amount
     * @param {Object|Any} cart 
     * @param {Boolean} recalculateAmount 
     */
    _postCartUpdate(cart, recalculateAmount = true){
        if(cart.id && cart.taxMode == 'ExternalAmount' && recalculateAmount){
            return this.updateExternalTaxAmounts(cart);
        }
        return cart;
    }

    updateCartForDiscounts(cartMeta, actions){
        if(!util.typeOf(cartMeta, 'object') || !util.typeOf(actions, 'array') || !cartMeta.id || !cartMeta.version){
            return util.sendValidationError(new Error('Invalid update request parameter'));
        }
        var request = {
            "version":cartMeta.version, 
            "actions":actions
        };
        return util.makePostRequest(this._cartsUrl(cartMeta.id), request).then(this._postCartUpdate.bind(this));
    }

    /**
     * Update External Tax Amounts
     * @param {Object} cart 
     */
    updateExternalTaxAmounts(cart){
        let actions = CartUtility.buildExternalTaxAmountRequests(cart);
        if(actions.length){
            return util.makePostRequest(this._cartsUrl(cart.id), {
                "version":cart.version, 
                "actions":actions
            });
        }
        return cart;
    }

    /**
     * Update Line Item Custom Fields
     * @param {Object} cartMeta 
     * @param {String} lineItemId 
     * @param {Object} customFields 
            Custom field will be removed if value is `null`
            Note: a custom field can't be removed if it is not present in cart
            Do not pass key if you don't want to alter value
            So each parameter here in customFields are optional
     */
    updateCartItemCustomFields(cartMeta, lineItemId, customFields){
        if(!util.typeOf(customFields, 'object')){
            return util.sendValidationError(new Error('Invalid customFields request parameter'));
        }
        var actions = Object.keys(customFields).map((name) => {

            // process field which should be set of string
            if( (name == 'userSelection'  || name == 'mcpDocumentsSource')){
                let fieldValue= util.objectToSetOfStrings(customFields[name]);
                if(this.initParams.supportV1){
                    customFields[name]=fieldValue;  
                    return {
                        "action": "setLineItemCustomField",
                        "lineItemId": lineItemId,
                        "name": name,
                        "value": customFields[name]
                    }  
                }
                if(this.initParams.supportV2){
                    customFields = util.getCustomFieldsV2(name,fieldValue,this.initParams,customFields);
                    return {
                        "action": "setLineItemCustomField",
                        "lineItemId": lineItemId,
                        "name": name+"V2",
                        "value": customFields[name+"V2"]
                    }
                }
            }

            return {
                "action": "setLineItemCustomField",
                "lineItemId": lineItemId,
                "name": name,
                "value": customFields[name]
            }
        });
        return this.updateCart(cartMeta, actions);
    }

    /**
     * Store Shipping Options into Cart
     * 
     * @param {Object} cart 
     * @param {Array} shippingPreferences 
     * @returns 
     */
    updateCartWithShippingOptions(cart, shippingPreferences){
        let actions = [];
        try{
            shippingPreferences.map(record => {
                // if custom Line Item Id is supplied, update it
                let customLineItemId = record.id ? record.id : undefined;
                let lineItemId = record.lineItemId ? record.lineItemId : undefined;
                let currencyCode = cart.totalPrice.currencyCode;
                if(!lineItemId){
                    return ;
                }
                if(!util.typeOf(record.promiseArrivalDate, 'undefined')){
                    if(this.initParams.supportV1){
                        actions.push({
                            "action": "setLineItemCustomField",
                            "lineItemId": lineItemId,
                            "name": "promisedArrivalDate",
                            "value": record.promiseArrivalDate
                        });
                    }
                    if(this.initParams.supportV2){
                        actions.push({
                            "action": "setLineItemCustomField",
                            "lineItemId": lineItemId,
                            "name": "promisedArrivalDateV2",
                            "value": util.getV2TransformedData({"promisedArrivalDate":record.promiseArrivalDate},"promisedArrivalDate")
                        });
                    }

                }
                // Search for existing Shipping Custom Line Item
                if(!customLineItemId){
                    let lang = this.LANG;
                    let label = this.SHIPPING_SERVICE_LABEL;
                    let shippingCustomLineItem = CartUtility.getCustomLineItemsByItemId(cart, lineItemId).find(i => i.name[lang] === label)
                    if(shippingCustomLineItem && shippingCustomLineItem.id){
                        customLineItemId = shippingCustomLineItem.id
                    }
                }
                // if customLineItemId is not supplied, then create new one
                if(!customLineItemId){
                    let customItem = {
                        name: this.SHIPPING_SERVICE_LABEL,
                        externalTotalCentAmount: record.externalCentAmount,
                        quantity: record.quantity,          // Optional, Default is 1
                        serviceName: record.serviceName,
                        qpShippingCarrierKey: record.qpShippingCarrierKey,
                        deliveryConstraints: record.deliveryConstraints,
                    };
                    if(record.externalTaxRate){
                        customItem.externalTaxRate = record.externalTaxRate
                    }
                    actions = actions.concat(CartUtility.prepareCustomLineItemRequest([customItem], lineItemId, currencyCode, this.LANG, true, cart.taxMode));
                }else{
                    actions = actions.concat(CartUtility.prepareCustomLineItemUpdateRequest(record, customLineItemId, currencyCode, cart.taxMode));
                }
            })
        }catch(e){
            return util.sendValidationError(e);
        }
        return this.updateCart(cart, actions);
    }

    /**
     * Update custom line items of Cart
     * 
     * @param {Object} cart 
     * @param {Array} customLineItems 
     * @returns 
     */
    updateCustomLineItems(cart, customLineItems = []){
        if(!cart)
            return util.sendValidationError(new Error('Cart is empty'));
        let actions = [];
        try{
            customLineItems.map(record => {
                // if custom Line Item Id is supplied, update it
                let customLineItemId = record.id ? record.id : undefined;
                let lineItemId = record.lineItemId ? record.lineItemId : undefined;
                let currencyCode = cart.totalPrice.currencyCode;
                let label = record.label ? record.label : undefined
                if(!lineItemId){
                    throw new Error('Line item id is missing');
                }
                if(!label){
                    throw new Error('Custom line item label is missing');
                }
                // Search for existing Custom Line Item
                if(!customLineItemId){
                    let lang = this.LANG;
                    let customLineItem = CartUtility.getCustomLineItemsByItemId(cart, lineItemId).find(i => i.name[lang] === label)
                    if(customLineItem && customLineItem.id){
                        customLineItemId = customLineItem.id
                    }
                }
                // if customLineItemId is not supplied, then create new one
                if(!customLineItemId){
                    let customItem = {
                        name: label,
                        externalTotalCentAmount: record.externalCentAmount
                    };
                    if(record.externalTaxRate){
                        customItem.externalTaxRate = record.externalTaxRate
                    }
                    actions = actions.concat(CartUtility.prepareCustomLineItemRequest([customItem], lineItemId, currencyCode, this.LANG, true, cart.taxMode));
                }else{
                    actions = actions.concat(CartUtility.prepareCustomLineItemUpdateRequest(record, customLineItemId, currencyCode, cart.taxMode));
                }
            })
        }catch(e){
            return util.sendValidationError(e);
        }
        return this.updateCart(cart, actions);
    }

    /**
     * Remove Item from cart by Id
     * @param {Object} cart
     * @param {String} lineItemId 
     */
    removeCartItem(cart, lineItemId){
        var actions = [];
        // search for customLineItems for lineItemId
        var relatedCustomLineItems = CartUtility.getCustomLineItemsByItemId(cart, lineItemId);
        if(relatedCustomLineItems.length){
            for(var i = 0, len = relatedCustomLineItems.length; i < len; i++){
                actions.push({
                    action: "removeCustomLineItem",
                    customLineItemId : relatedCustomLineItems[i].id
                });
            }
        }
        actions.push({
            "action":"removeLineItem", 
            "lineItemId":lineItemId
        });
        return this.updateCart(cart, actions);
    }

    /**
     * Batch Delete Cart Line Items & Custom Line Items
     * @param {Object} cartMeta 
     * @param {Array} lineItemIds 
     * @param {Array} customLineItemIds 
     */
    removeCartItems(cartMeta, lineItemIds = [], customLineItemIds = []){
        let actions = [];
        if(util.typeOf(customLineItemIds, 'array') && customLineItemIds.length){
            for(let i = 0, len = customLineItemIds.length; i < len; i++){
                actions.push({
                    action: "removeCustomLineItem",
                    customLineItemId : customLineItemIds[i]
                });
            }
        }
        if(util.typeOf(lineItemIds, 'array') && lineItemIds.length){
            for(let i = 0, len = lineItemIds.length; i < len; i++){
                actions.push({
                    action: "removeLineItem",
                    lineItemId : lineItemIds[i]
                });
            }
        }
        return this.updateCart(cartMeta, actions);
    }

    /**
     * Create order from cart
     * orderNumber: String that uniquely identifies an order. 
     * It can be used to create more human-readable (in contrast to ID) identifier for the order. It should be unique across a project. Once it’s set it cannot be changed.
     * @param {Object} cartMeta 
     * @param {Object} customFields
     *  {
            deviceInfo : Abc.order.objectToSetOfStrings(deviceInfo),
            deviceIPAddress : "127.0.0.1"
        }
     * @param {String} paymentState Paid
     * @param {String} orderState Confirmed
     * @param {Array} orderTransitionStates Confirmed/Confirmed_order
     * @param {String} orderNumber 
     * @param {Boolean} addDelivery 
     * @param {Array} additionalUpdateActions
     * @param {Array|null} itemTransitionStates 
     */
    createOrder(cartMeta, customFields, paymentState, orderState, orderTransitionStates, orderNumber, addDelivery = true, additionalUpdateActions = [], itemTransitionStates = null, generateOrderNumber = true, doItemStateTransition = true){
        var _this = this;
        return new Promise(function (resolve, reject) {
            parallel({
                order: function(callback) {
                    _this.getCartById(cartMeta.id).then(function(_cart){
                        if(!_cart.id){
                            return callback(null, _cart);
                        }
                        var request = {
                            'id': _cart.id,
                            'version': _cart.version,
                            'paymentState': paymentState ? paymentState : 'Pending',
                        };
                        if(generateOrderNumber){
                            request['orderNumber'] = orderNumber ? orderNumber : util.generateOrderNumber()
                        }
                        util.makePostRequest(_this._ordersUrl(), request).then(_this._dispatchOrderIsCreated.bind(_this)).then(function(_order){
                            callback(null, _order);
                        });
                    });

                },
                states: function(callback) {
                    _this.getStates().then(function(_states){
                        if(_states.error){
                            return callback(_states);
                        }
                        callback(null, _states);
                    });
                }
            }, function(err, results) {
                // Both calls ended
                if(err){
                    // for error also we do not need reject
                    return resolve(err);
                }

                if(!results.order || !results.order.id){
                    // order creation failed
                    return resolve(results.order);
                }

                // Do line Item state transitions & Order updates
                var actions = [];
                if(!results.order.custom || !results.order.custom.type){
                    // order custom fields are not enabled yet
                    actions.push({
                        "action": "setCustomType",
                        "type": {
                            "key": "orderCustomFields"
                        }
                    });
                }

                if(util.typeOf(orderState, 'string')){
                    // udate order state to Confirmed / Open
                    actions.push({
                        "action": "changeOrderState",
                        "orderState": orderState
                    });
                }

                // Update customFields if supplied
                if(util.typeOf(customFields, 'object') && Object.keys(customFields).length){
                    // if custom fields exists in customFields, Loop them and create action
                    for (var i = 0, keys = Object.keys(customFields), len = keys.length; i < len; i++) {
                        actions.push({
                            "action": "setCustomField",
                            "name": keys[i],
                            "value": customFields[keys[i]]
                        });
                    }
                }

                // Add actions to Update LineItemState
                if(util.typeOf(results.states.results, 'array')){

                    // in case user supplied string instead of set of states
                    if(util.typeOf(orderTransitionStates, 'string')){
                        orderTransitionStates = [orderTransitionStates];
                    }
                    if(util.typeOf(orderTransitionStates, 'array')){
                        for(let i = 0, len = orderTransitionStates.length; i < len; i++){
                            // update order transition state to Confirmed
                            let orderTransitionStateDetails = CartUtility.getFilteredStateByType(results.states.results, orderTransitionStates[i], 'OrderState');
                            actions.push({
                                "action": "transitionState",
                                "state": {
                                    "typeId": "state",
                                    "id": orderTransitionStateDetails.id
                                }
                            });
                        }
                    }
                    
                    var lineItemConfirmState = CartUtility.getFilteredStateByType(results.states.results, _this.STATE.ITEM_CONFIRMED, 'LineItemState');
                    if(lineItemConfirmState.id && doItemStateTransition){

                        var lineItemDocUploadState = CartUtility.getFilteredStateByType(results.states.results, _this.STATE.ITEM_WAITING_FOR_ARTWORK, 'LineItemState');
                        var lineItemReviewState = CartUtility.getFilteredStateByType(results.states.results, _this.STATE.ITEM_WAITING_FOR_DOC_REVIEW, 'LineItemState');

                        // Add action to update all LineItem state in `Confirmed`
                        for(var i = 0, len = results.order.lineItems.length; i < len; i++){
                            var item = results.order.lineItems[i];
                            let isReadyForFulFillment = item.custom && !util.typeOf(item.custom.fields.artworkRequired, 'undefined') && (_this.initParams.supportV1?(item.custom.fields.artworkRequired.toUpperCase() === 'NO'):(_this.initParams.supportV2?!(item.custom.fields.artworkRequired):false))
                            // update line item state to 'confirmed'
                            if(item.state){

                                actions.push({
                                    "action": "transitionLineItemState",
                                    "lineItemId": item.id,
                                    "quantity":item.quantity,
                                    "fromState": item.state[0].state,
                                    "toState": {
                                        "typeId": "state",
                                        "id": lineItemConfirmState.id
                                    }
                                });

                                if(isReadyForFulFillment){
                                    // for Items ready for Fulfillment, transition state to ITEM_READY_FOR_FULFILLMENT
                                    let lineItemReadyForFulfillmentState = CartUtility.getFilteredStateByType(results.states.results, _this.STATE.ITEM_READY_FOR_FULFILLMENT, 'LineItemState');
                                    if(lineItemReadyForFulfillmentState.id){
                                        actions.push({
                                            "action": "transitionLineItemState",
                                            "lineItemId": item.id,
                                            "quantity":item.quantity,
                                            "fromState": {
                                                "typeId": "state",
                                                "id": lineItemConfirmState.id
                                            },
                                            "toState": {
                                                "typeId": "state",
                                                "id": lineItemReadyForFulfillmentState.id
                                            }
                                        });
                                    }
                                }
                                // Transition item into all states one by one, if supplied
                                else  if(util.typeOf(itemTransitionStates, 'array')){
                                    let lastStateId = lineItemConfirmState.id;

                                    for(let i = 0, len = itemTransitionStates.length; i < len; i++){
                                        // update item transition state to specified one
                                        let stateDetails = CartUtility.getFilteredStateByType(results.states.results, itemTransitionStates[i], 'LineItemState');
                                        if(stateDetails.id){
                                            actions.push({
                                                "action": "transitionLineItemState",
                                                "lineItemId": item.id,
                                                "quantity":item.quantity,
                                                "fromState": {
                                                    "typeId": "state",
                                                    "id": lastStateId
                                                },
                                                "toState": {
                                                    "typeId": "state",
                                                    "id": stateDetails.id
                                                }
                                            });
                                            lastStateId = stateDetails.id;
                                        }
                                    }
                                }
                                // at same time update line item state to 'WaitingForArtwork'
                                else if(lineItemDocUploadState.id){
                                    actions.push({
                                        "action": "transitionLineItemState",
                                        "lineItemId": item.id,
                                        "quantity":item.quantity,
                                        "fromState": {
                                            "typeId": "state",
                                            "id": lineItemConfirmState.id
                                        },
                                        "toState": {
                                            "typeId": "state",
                                            "id": lineItemDocUploadState.id
                                        }
                                    });

                                    if(item.custom && lineItemReviewState.id && 
                                        (
                                            // If Line Item has mcpDocument Details then update state to 'WaitingForDocReview'
                                            (item.custom.fields.mcpDocumentsSource && item.custom.fields.mcpDocumentsSource.length) ||
                                            // If Line Item has userUploadComplete = true & has userUploadsUrl then also update state to `WaitingForDocReview`
                                            (item.custom.fields.userUploadComplete && util.typeOf(item.custom.fields.userUploadsUrl, 'array') && item.custom.fields.userUploadsUrl.length)
                                        )
                                    ){
                                        actions.push({
                                            "action": "transitionLineItemState",
                                            "lineItemId": item.id,
                                            "quantity":item.quantity,
                                            "fromState": {
                                                "typeId": "state",
                                                "id": lineItemDocUploadState.id
                                            },
                                            "toState": {
                                                "typeId": "state",
                                                "id": lineItemReviewState.id
                                            }
                                        });
                                    }
                                }
                            }

                            // Add `addDelivery` action for each line Item
                            if(addDelivery && item.custom && (item.custom.fields.shippingAddressPerLineItem!=undefined || item.custom.fields.shippingAddressPerLineItemV2!=undefined)){
                                actions.push({
                                    "action" : "addDelivery",
                                    "items":[{
                                        "id": item.id,
                                        "quantity":item.quantity
                                    }],
                                    "address" : util.getV2TransformedData
                                });
                            }

                            actions = actions.concat(additionalUpdateActions);
                        }
                    }
                }

                return _this.updateOrder(results.order, actions).then(function(_order){
                    // resolve once order is updated
                    resolve(_order);
                });
            });
        });
    }

    /**
     * Dispatch Order Created Event
     * @param {Object} res 
     */
    _dispatchOrderIsCreated(res){
        if(res.id){
            this._EventBus.dispatch(this.EVENT_ORDER_CREATED, res);
        }
        return res;
    }

    /**
     * Dispatch Order Updated Event
     * @param {Object} res 
     */
    _dispatchOrderIsUpdated(res){
        if(res.id){
            this._EventBus.dispatch(this.EVENT_ORDER_UPDATED, res);
        }
        return res;
    }

    /**
     * Dispatch Order Fetched Event
     * @param {Object} res 
     */
    _dispatchOrderIsFetched(res){
        if(res.id){
            this._EventBus.dispatch(this.EVENT_ORDER_FETCHED, res);
        }
        return res;
    }

    /**
     * Update Order info
     * @param {Object} orderMeta 
     * @param {Array} actions 
     */
    updateOrder(orderMeta, actions){
         var request = {
            "version":orderMeta.version, 
            "actions":actions
        };
        return util.makePostRequest(this._ordersUrl(orderMeta.id), request).then(this._dispatchOrderIsUpdated.bind(this));
    }

    /**
     * Update order items with Upload info
     * @param {Object} orderMeta 
     * @param {String} lineItemId 
     * @param {Array} filesUploaded 
     */
    updateOrderItemUploads(orderMeta, lineItemId, filesUploaded){
        var uploadsList = [];
        for(var i in filesUploaded){
            uploadsList.push(filesUploaded[i].handle+'::'+filesUploaded[i].filename+'::'+filesUploaded[i].url+'::'+(util.typeOf(filesUploaded[i].timestamp, 'string') ? filesUploaded[i].timestamp : (new Date()).toISOString()));
        }
        let updateActions=[];
        if(this.initParams.supportV1){
            updateActions.push({
                "action": "setLineItemCustomField",
                "lineItemId": lineItemId,
                "name": "userUploadsUrl",
                "value": uploadsList
            });
        }
        if(this.initParams.supportV2){
            updateActions.push({
                "action": "setLineItemCustomField",
                "lineItemId": lineItemId,
                "name": "userUploadsUrlV2",
                "value": util.getCustomFieldsV2("userUploadsUrl",uploadsList,this.initParams).userUploadsUrlV2
            });
        }
        return this.updateOrder(orderMeta,updateActions);
    }

    /** 
     * Marks userUploadComplete custom field as TRUE.
     * Transits line item state as WaitingForDocReview
     * 
     * @param {Object} orderMeta
     * @param {Object} lineItem
     * 
     * **/ 
    updateLineItemUserUploadStatus(orderMeta, lineItem){
        //Get line item states
        var _this = this;
        return this.getStates().then(function(states){
            if(states.results){
                var actions = [];
                var lineItemReviewState = CartUtility.getFilteredStateByType(states.results, _this.STATE.ITEM_WAITING_FOR_DOC_REVIEW, 'LineItemState');
                //Add actions for updating the line item custom field for User uploads and change state of the line item state
                if(lineItemReviewState.id){
                    // Line Item State found
                    actions.push({
                        "action": "setLineItemCustomField",
                        "lineItemId": lineItem.id,
                        "name": "userUploadComplete",
                        "value": true
                    });

                    actions.push({
                        "action": "transitionLineItemState",
                        "lineItemId": lineItem.id,
                        "quantity": lineItem.quantity,
                        "fromState": lineItem.state[0].state,
                        "toState": {
                            "typeId": "state",
                            "id": lineItemReviewState.id
                        }
                    });
                    return _this.updateOrder(orderMeta, actions);
                }

            }
            return states;
        });
        
    }

    /**
     * Update LineItem State By key
     * @param {Object} orderMeta 
     * @param {Object} lineItem 
     * @param {String} stateIdentifier 
     */
    updateLineItemState(orderMeta, lineItem, stateIdentifier){
        let _this = this;
        return this.getStates().then(function(states){
            if(states.results){
                let actions = [];
                // search state object for given state
                let lineItemState = CartUtility.getFilteredStateByType(states.results, stateIdentifier, 'LineItemState');
                if(lineItemState.id){
                    actions.push({
                        "action": "transitionLineItemState",
                        "lineItemId": lineItem.id,
                        "quantity": lineItem.quantity,
                        "fromState": lineItem.state[0].state,
                        "toState": {
                            "typeId": "state",
                            "id": lineItemState.id
                        }
                    });
                    return _this.updateOrder(orderMeta, actions);
                }
            }
            return util.sendValidationError(new Error('Invalid stateIdentifier parameter'));
        });
    }

    /**
     * get order by id
     * @param {String} orderId 
     */
    getOrderById(orderId, params) {
        return util.makeGETRequest(this._ordersUrl(orderId), params).then(this._dispatchOrderIsFetched.bind(this)); 
    }

    /**
     * get Customer's orders
     * @param {Number} limit
     * @param {Number} offset
     * @param {String} sort
     * @param {String} predicate
     */
    getCustomerOrders(limit, offset, sort, predicate = null){
        return util.makeGETRequest(this._myOrdersUrl, {
            where: predicate,
            limit: limit ? limit : 50,
            offset: offset ? offset : 0,
            sort: sort ? sort : 'createdAt desc'
        });
    }

    /**
     * get Shipping Methods
     * @param {Number} limit 
     * @param {Number} offset 
     */
    getShippingMethods(limit, offset){
        return util.makeGETRequest(this._shippingMethodsUrl(), {
            limit: limit ? limit : 50,
            offset: offset ? offset : 0,
        }); 
    }

    /**
     * get States
     * @param {Number} limit 
     * @param {Number} offset 
     */
    getStates(limit, offset){
        return util.makeGETRequest(this._statesUrl(), {
            limit: limit ? limit : 50,
            offset: offset ? offset : 0,
        }); 
    }

    /**
     * Exposing Object to Set Of Strings Util function
     * @param {Object} obj 
     */
    objectToSetOfStrings(obj){
        return util.objectToSetOfStrings(obj);
    }
    
    /**
     * Exposing Set of Strings to Object Util function
     * @param {Array} stringSet 
     */
    setOfStringsToObject(stringSet){
        return util.setOfStringsToObject(stringSet);
    }
    
    /**
     * Build set of variableAttributes
     * 
     * @param {String} LANG 
     * @param {Object} variantInfo 
     * @param {Object} userSelection 
     * @param {Array} tenantDefinations 
     * @param {Object} finalSelections 
     * @param {Array} variableOverrides 
     * @returns {Object}
     */
    prepareVariableAttributes(LANG, variantInfo, userSelection, tenantDefinations, finalSelections, variableOverrides){
        return CartUtility.buildVariableAttributes(LANG, variantInfo, userSelection, tenantDefinations, finalSelections, variableOverrides);
    }

    /**
     * Search All Custom Line Items by Line Item Id
     * @param {Object} cart 
     * @param {String} lineItemId 
     */
    getCustomLineItemsByItemId(cart, lineItemId){
        return CartUtility.getCustomLineItemsByItemId(cart, lineItemId);
    }

    /**
     * get Calculated Effective Price of Line Items
     * 
        taxedPrice : {
            "currencyCode": "GBP",
            "totalGrossCentAmount": 5824,// Inc. VAT, will be `null` if tax is not applied to cart yet
            "totalNetCentAmount": 5600,// Without VAT
            "totalTaxCentAmount": 933   //  VAT amount
        }
        effectivePrice

     * 
     * @param {Object} cart 
     * @param {String} lineItemId 
     * @param {Array} excludeCustomLineItems
     */
    getItemEffectivePrice(cart, lineItemId, excludeCustomLineItems = []){
        return CartUtility.calculateEffectivePrice(cart, lineItemId, this.initParams.lang, excludeCustomLineItems);
    }

    /**
     * Get updated Cart object containing effective price at Line Item and Order level in the key 'effectivePrice'        
     * 
     * @param {Object} cart 
     * @param {Boolean} includeShippingInfo
     * @param {Array} excludeCustomLineItems
     *
     */
    getProcessedCart(cart, includeShippingInfo = false, excludeCustomLineItems = []){
        return CartUtility.getProcessedCart(cart, includeShippingInfo, this.initParams.lang, excludeCustomLineItems);
    }

    /**
    * Get Discount-code description  
    * @param {String} discountCode
    * returns the reults of the query 
    */
    _getDiscountCodeDescription(discountCode){
        return util.makeGETRequest(this._discountCodesUrl(discountCode, 'code')).then(function(pageQueryResults){
            return pageQueryResults.results;
        });
    };

    /**
     * get cart and update External Amount if needed
     * @param {Object} response 
     */
    _getUpdatedCart(response){
        var me=this;
        if(response.cartId){
            return me.getCartById(response.cartId).then(this._postCartUpdate.bind(this));
        }
        return response;
    }
    /**
    * calculate total discounts on cart with 
    * @param {Object} cart 
    */
    calculateTotalDiscountsCart(cart){
        var totalDiscountCalculation=0;
        for(var iterator in cart.lineItems){
            totalDiscountCalculation+=Math.round(cart.lineItems[iterator].custom.fields.originalLineItemAmount.centAmount-cart.lineItems[iterator].totalPrice.centAmount);
        };
        for(var iterator in cart.customLineItems){
            if(cart.customLineItems[iterator].discountedPricePerQuantity.length>0)
            totalDiscountCalculation+=Math.round(cart.customLineItems[iterator].discountedPricePerQuantity[0].quantity*cart.customLineItems[iterator].discountedPricePerQuantity[0].discountedPrice.includedDiscounts[0].discountedAmount.centAmount);
        }
        return totalDiscountCalculation;
    };
    
    checkDiscountCodePresent(cart, discountCode){
        return this._getDiscountCodeDescription(discountCode).then(function(results){
            if(results[0] && results[0].id && cart.discountCodes.length>0){
                for (var i = 0; i < cart.discountCodes.length; i++) {
                    if(cart.discountCodes[i].discountCode.id==results[0].id){
                        return true;
                    }
                }
                return false;
            }
            else return false;
        });
    };
    /**
    * comapct function for application of discountCode
    */
    applyCode(cartMeta, userId, discountCode, isLoggedIn){
        let request = {
          "cartId": cartMeta.id,
          "discountCode": discountCode,
          "isLoggedIn": isLoggedIn,
          "userId": userId
        };
        return util.makePostRequest(this._applyCouponDiscountUrl, request).then(this._getUpdatedCart.bind(this)).then(this._dispatchCartIsUpdated.bind(this));
    };

    removeDiscountCodeOnCart(cartMeta, discountCodeOrId,discountCodePassed){
        let request = {
          "cartId":cartMeta.id
        };
        if(discountCodePassed==null || discountCodePassed==true){
            request.discountCode=discountCodeOrId;
        }
        else{
            request.discountId=discountCodeOrId;
        }
        return util.makePostRequest(this._removeCouponDiscountUrl, request).then(this._getUpdatedCart.bind(this)).then(this._dispatchCartIsUpdated.bind(this));

        
    };

    //call this function if on refresh the discount code is applied to a cart
    reCalculateDiscount(cart){
        // For non `ExternalAmount` tax Mode, this is taken Care by Ctool itself.
        if(cart.taxMode && cart.taxMode !== 'ExternalAmount'){
            return Promise.resolve(cart);
        }
        return util.makePostRequest(this._reCalculateCouponDiscountUrl, {
            "cartId": cart.id
        }).then(this._getUpdatedCart.bind(this)).then(this._dispatchCartIsUpdated.bind(this));

    };

    getDiscountCodeById(discountId){
        return util.makeGETRequest(this._discountCodesUrl(discountId));
    }

    /**
     * get review comment for a order line Item
     * 
     * @param {String} businessUnit 
     * @param {String} orderId 
     * @param {String} lineItemId 
     */
    getReviewComments(businessUnit, orderId, lineItemId){
        return util.makeGETRequest(this._getReviewComments(businessUnit, orderId, lineItemId));
    }

    /**
     * Store Review Comment
     * @param {Object} request 
     */
    storeReviewComment(request){
        return util.makePostRequest(this._saveReviewCommentUrl, request);
    }

    /**
     * get comment for a order from V1 endpoint
     *
     * @param {String} orderId
     */
    getComments(orderId){
        return util.makeGETRequest(this._getCommentsV1Url(orderId));
    }

    /**
     * Store Comment via V1 endpoint
     * @param {Object} request
     */
    storeComment(request){
        return util.makePostRequest(this._saveCommentV1Url, request);
    }

    /**
     * get Payment Info by Id
     * @param {String} paymentId 
     */
    getPaymentById(paymentId){
        return util.makeGETRequest(this._paymentsUrl(paymentId));
    }

    /**
     * get Shipping Methods for Each Line Items
     * 
     * @param {Object} cart 
     * @param {Object} lineItemAddresses 
     * @param {String} merchantId 
     * @param {String} fulfillmentLocationId 
     */
    getShippingOptions(cart, lineItemAddresses, merchantId, fulfillmentLocationIdentifier = undefined){
        let lineItems = Object.keys(lineItemAddresses).map(itemId => {
            let item = cart.lineItems.find(
                i => i.id === itemId
            );
            if(item){
                let variableAttributes = undefined;
                if(item.custom){
                    variableAttributes=util.getV2TransformedData(item.custom.fields,"variableAttributes");
                }
                let fulfillmentLocationId;
                if(fulfillmentLocationIdentifier && item.variant && item.variant.attributes){
                    let attribute = item.variant.attributes.find(a => a.name === fulfillmentLocationIdentifier);
                    if(attribute && attribute.value && util.typeOf(attribute.value, 'array') && attribute.value.length){
                        fulfillmentLocationId = attribute.value[0].key;
                    }
                }
                let bufferArtworkServiceHoursV2=util.getV2TransformedData(item.custom.fields,"bufferArtworkServiceHours");
                let bufferproductionHoursV2=util.getV2TransformedData(item.custom.fields,"bufferProductionHours");
                let productionTimeV2=util.getV2TransformedData(item.custom.fields,"mcpProductionHours");
                let variableAttributesv1Transformed=util.setOfStringsToObject(util.getV1TransformedData(variableAttributes,"variableAttributes"));
                return {
                    lineItemId: itemId,
                    productId: item.productId,
                    productKey: item.custom && item.custom.fields.productKey ? item.custom.fields.productKey : undefined,
                    mcpSku: item.custom && item.custom.fields.mcpSku ? item.custom.fields.mcpSku : undefined,
                    quantity: item.quantity,
                    currency: cart.totalPrice.currencyCode,
                    shipToAddress: lineItemAddresses[itemId],
                    variableAttributes: Object.keys(variableAttributesv1Transformed).map(label=>{
                        return{
                            "name":label,
                            "value": variableAttributesv1Transformed[label]
                        }
                    }),
     
                    bufferArtworkServiceHours:  bufferArtworkServiceHoursV2!=undefined?util.getV1TransformedData(bufferArtworkServiceHoursV2,"bufferArtworkServiceHours"):"0",
                    bufferProductionHours: bufferproductionHoursV2!=undefined?util.getV1TransformedData(bufferproductionHoursV2,"bufferProductionHours"):"0",
                    productionTime:productionTimeV2!=undefined?util.getV1TransformedData(productionTimeV2,"mcpProductionHours"):"48",
                    merchantId,
                    promisedArrivalDate: util.getV2TransformedData(item.custom.fields,"promisedArrivalDate"),
                    fulfillmentLocationId : fulfillmentLocationId,
                    productTypeId: item.productType.id,
                }
            }
        })

        let request = {
            cartId: cart.id,
            lineItems
        }
        return util.makePostRequest(this._getShippingOptionsUrl, request);
    }

    async _getTenantDefinition(productTypeId){
        return await util.makeGETRequest(this._getTenantDefinitionUrl(productTypeId));
    }
    

    async _getShoppingListById(shoppingListId){
        return  util.makeGETRequest(this._shoppingListUrl(shoppingListId));
    }

    /**
     * add line item to cart with given shopping list id for 
     * @param {String} shoppingListData 
     * @param {String} lineItemId
     * @param {String} customerId 
     * @param {Object} address  should be of the type AddressType
     * @param {Object} carrierKeys //array of carrier Keys
     * @param {String} merchantId 
     * @param {String} lineItemNumber 
     */
    async addItemToCartFromShoppingList(shoppingListData,address,carrierKeys,merchantId,callViaItemDelivery=0,taxMode,lineItemNumber,addOnCustomFields){
        //get the cart against customer
        if(util.typeOf(shoppingListData, 'object') && shoppingListData.id){
            
            //validate the price
            //shoppingListData=await this._getShoppingListById(shoppingListData.id);
            if(shoppingListData && shoppingListData.id){
                let cart=null;
                let updatedCart={};
                let customerId=shoppingListData.customer.id;
                cart=await this.getCart(customerId,true);
                let lineItem;
                if(shoppingListData.lineItems.length){
                    lineItem=shoppingListData.lineItems[0];
                }else{
                    throw new Error("no items in shopping list passed");
                }
                if(lineItem){
                    let lineItemRequest={};
                    if(util.typeOf(lineItem.productId, 'string')){ 
                        lineItemRequest.productId=lineItem.productId;
                    }
                    if(util.typeOf(lineItem.variantId, 'number')){ 
                        lineItemRequest.variantId=lineItem.variantId;
                    }
                    let externalTaxRate=JSON.parse(lineItem.custom.fields.externalTaxRateDraft);
                    lineItemRequest.externalTaxRate=externalTaxRate;
                    lineItemRequest.quantity=lineItem.quantity;
                    //get promised Arrival Date for the recent Item
                    lineItemRequest.customFields = lineItem.custom.fields;
                    lineItemRequest.merchandisingProductName=lineItem.custom.fields.merchandisingProductName==undefined?"":lineItem.custom.fields.merchandisingProductName;
                    lineItemRequest.customLineItems=CartUtility.getCustomLineItems(shoppingListData,lineItem.id); // get the text line items asscoiated with line items for shopping lists
                    lineItemRequest.userSelection=util.setOfStringsToObject(lineItemRequest.customFields.userSelection);
                    lineItemRequest.externalTotalCentAmount=lineItemRequest.customFields.originalLineItemAmount.centAmount;
                    lineItemRequest.currencyCode=lineItemRequest.customFields.originalLineItemAmount.currencyCode
                    let finalSelections=util.setOfStringsToObject(lineItemRequest.customFields.finalSelection);
                    if (util.typeOf(finalSelections, 'array') && finalSelections.length) {
                        lineItem.finalSelections = lineItem.finalSelections.reduce((obj, attribute) => {
                            obj[attribute.attributeKey] = attribute.attributeValue;
                            return obj
                        }, {});
                    }
                    let deliveryData=await CartUtility.getUpdatedArrivalDate(this._shippingRecalculateArrivalDateUrl,lineItemRequest.customFields.productKey,lineItem.quantity,merchantId,finalSelections, lineItemRequest.customFields.bufferArtworkServiceHours, lineItemRequest.customFields.bufferProductionHours, lineItemRequest.customFields.mcpProductionHours,
                        carrierKeys,
                        address,  null,
                        null, lineItem.productType.id,(new Date()).toISOString(),callViaItemDelivery);
                    if(deliveryData){
                        lineItemRequest.promisedArrivalDate=deliveryData.date;
                    }
                    // get tenant definition for the given product
                    lineItemRequest.tenantDefinations=await this._getTenantDefinition(lineItem.productType.id);
                    // Note:  lineItemNumber Must be defined otherwise Custom Line Items will not be created
                    if (util.typeOf(lineItemNumber, 'string')) {
                        lineItemRequest.customFields.lineItemNumber = lineItemNumber;
                    } else {
                    // build own if not suplied
                    lineItemRequest.customFields.lineItemNumber = util.generateLineItemNumber();
                    }
                    //if add on custom fields passed append to currently custom fields
                    if(addOnCustomFields && !Object.keys(addOnCustomFields).length === 0 && !addOnCustomFields.constructor === Object){
                        lineItemRequest.customFields=Object.assign(objectToMergeTo, lineItemRequest.customFields, addOnCustomFields)
                    }
                    if(cart && cart.id){
                        // update exixting cart
                        updatedCart=await this.addItemInCart(cart,lineItemRequest,{},null,taxMode?taxMode:"External");
                    }else{
                        //if not present create new cart
                        updatedCart=await this.newCart(lineItemRequest,customerId,true,{},null,taxMode?taxMode:"External",customerId,true);
                    }
                }
                else{
                    //line Item id does not exist
                    throw new Error("line Item with id does not exist "+lineItemId);
                }
                return updatedCart;
            }else{
                throw new Error("Shopping list id not valid");
            }
        }else{
            throw new Error("Invalid data");
        }
    }
    
}


// WEBPACK FOOTER //
// ./src/order/OrderService.js